export default __webpack_public_path__ + "static/media/zido.46e03fe8.svg";